import { integrationLabel } from "../../../utils/integrations";

// Keyed by canonical app key; labels come from the registry.
const appEntry = (key, short) => ({
  label: { ar: integrationLabel(key, "ar"), en: integrationLabel(key, "en") },
  short,
});

export const APPS = {
  keeta: appEntry("keeta", { ar: "كـ", en: "K" }),
  hungerstation: appEntry("hungerstation", { ar: "هـ", en: "H" }),
  jahez: appEntry("jahez", { ar: "جـ", en: "J" }),
  marsool: appEntry("marsool", { ar: "م", en: "M" }),
  ninja: appEntry("ninja", { ar: "ن", en: "N" }),
  toyou: appEntry("toyou", { ar: "ت", en: "T" }),
};

export const CATEGORIES = [
  {
    key: "orgdocs",
    label: { ar: "مستندات المؤسسة", en: "Organization Documents" },
  },
  {
    key: "contracts",
    label: { ar: "عقود التطبيقات", en: "App Contracts" },
  },
  {
    key: "statements",
    label: { ar: "كشوفات الحساب", en: "Account Statements" },
  },
  {
    key: "updates",
    label: { ar: "تحديثات", en: "Update Requests" },
  },
  {
    key: "daily",
    label: { ar: "التقرير اليومي", en: "Daily Report" },
  },
  {
    key: "monthly",
    label: { ar: "التقرير الشهري", en: "Monthly Report" },
  },
  {
    key: "itemsales",
    label: { ar: "مبيعات الأصناف", en: "Item Sales" },
  },
];

export const DAILY_SPEC = {
  jahez: [
    { ar: "الطلبات", en: "Orders" },
    { ar: "التعويضات", en: "Compensations" },
  ],
  hungerstation: [{ ar: "الطلبات", en: "Orders" }],
  keeta: [{ ar: "الطلبات", en: "Orders" }],
  ninja: [
    { ar: "الطلبات", en: "Orders" },
    { ar: "التعويضات", en: "Compensations" },
  ],
  marsool: [
    { ar: "الطلبات", en: "Orders" },
    { ar: "التعويضات", en: "Compensations" },
  ],
  toyou: [
    { ar: "الطلبات", en: "Orders" },
    { ar: "التعويضات", en: "Compensations" },
  ],
};

export const MONTHLY_SPEC = {
  jahez: [
    {
      name: { ar: "اكسل الطلبات", en: "Orders Excel" },
      source: "daily",
    },
    {
      name: { ar: "اكسل التعويضات", en: "Compensations Excel" },
      source: "daily",
    },
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
    {
      name: { ar: "الفاتورة الضريبية", en: "Tax invoice" },
      source: "manual",
    },
  ],
  ninja: [
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
    {
      name: { ar: "اكسل التعويضات", en: "Compensations Excel" },
      source: "daily",
    },
    {
      name: { ar: "الفواتير الضريبية", en: "Tax invoices" },
      source: "manual",
      count: 5,
    },
  ],
  toyou: [
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
    {
      name: { ar: "الفاتورة الضريبية", en: "Tax invoice" },
      source: "manual",
    },
  ],
  hungerstation: [
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
    {
      name: { ar: "الفاتورة الضريبية", en: "Tax invoice" },
      source: "manual",
    },
  ],
  keeta: [
    {
      name: { ar: "اكسل الطلبات", en: "Orders Excel" },
      source: "daily",
    },
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
    {
      name: { ar: "الفاتورة الضريبية", en: "Tax invoice" },
      source: "manual",
    },
  ],
  marsool: [
    {
      name: { ar: "الفاتورة الضريبية", en: "Tax invoice" },
      source: "manual",
    },
    {
      name: {
        ar: "اكسل التقرير الشهري",
        en: "Monthly report Excel",
      },
      source: "manual",
    },
  ],
};

export const APP_STATUS = {
  active: {
    label: { ar: "فعّال", en: "Active" },
    variant: "success",
    needsFiles: true,
  },
  in_progress: {
    label: { ar: "جاري العمل", en: "In progress" },
    variant: "success",
    needsFiles: true,
  },
  closed: {
    label: { ar: "مغلق", en: "Closed" },
    variant: "danger",
    needsFiles: false,
  },
  closed_temp: {
    label: { ar: "إغلاق مؤقت", en: "Temporarily closed" },
    variant: "warning",
    needsFiles: false,
  },
  code_pending: {
    label: { ar: "كود", en: "Code" },
    variant: "warning",
    needsFiles: false,
  },
  registration: {
    label: { ar: "تسجيل", en: "Registration" },
    variant: "neutral",
    needsFiles: false,
  },
  inactive: {
    label: { ar: "غير فعال", en: "Inactive" },
    variant: "neutral",
    needsFiles: false,
  },
};

export const MONTH_NAMES = {
  ar: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

export const TEXT = {
  uploadZone: {
    ar: "اسحب ملفاً هنا أو اضغط للرفع اليدوي",
    en: "Drag a file here or click to upload manually",
  },
  uploadZoneDisabled: {
    ar: "قم باختيار العنصر أولاً",
    en: "Select an item first",
  },
  sections: {
    ar: "الأقسام",
    en: "Sections",
  },
  admin: {
    ar: "نظرة إدارية شاملة",
    en: "Admin Overview",
  },
  back: {
    ar: "رجوع للمطاعم",
    en: "Back to restaurants",
  },
  add: {
    ar: "إضافة",
    en: "Add",
  },
};